import { Plane } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

const getPlaneFromShape = (shape: ImmutableVector3[]): Plane => {
  return new Plane().setFromCoplanarPoints(shape[0].v, shape[1].v, shape[2].v)
}

export default getPlaneFromShape
